module.exports = __webpack_public_path__ + "static/media/and_scr_onboarding_02_a.7e3f7e23.png";